// extracted by mini-css-extract-plugin
export default {"list":"Pg_1_5_list__+1GrQ","timeBar":"Pg_1_5_timeBar__Y-eF0","bar":"Pg_1_5_bar__YwbVv"};